import { FC, lazy } from 'react';
import { DraftedProductsParams } from 'src/apis/capacity-management/types';
import { useCapacityCategories } from 'src/apis/capacity-management/use-capacity-categories';
import { CapacityManagementRootRequest } from 'src/apis/capacity-management/use-capacity-management-root';
import { useDraftedProducts } from 'src/apis/capacity-management/use-drafted-products';
import { usePageParams } from 'src/pages/reporting/products/drafted/overview/use-page-params';
import { useMemoOne } from 'use-memo-one';

const Page = lazy(() => import('./page'));

type Props = { capacityManagementRoot: CapacityManagementRootRequest };

export const ReportingUploadsDraftedOverview: FC<Props> = ({
  capacityManagementRoot,
}) => {
  const pageParams = usePageParams();

  const params = useMemoOne<DraftedProductsParams>(() => {
    const { start, networkPointId, ...rest } = pageParams.value;
    return {
      offset: start,
      networkPointId: networkPointId.map((id) => id.value),
      ...rest,
    };
  }, [pageParams.value]);

  const draftedProducts = useDraftedProducts({
    capacityManagementRoot,
    params,
  });

  const capacityCategories = useCapacityCategories({
    capacityManagementRoot,
    scope: 'organisation',
  });

  return (
    <Page
      draftedProducts={draftedProducts}
      pageParams={pageParams}
      capacityCategories={capacityCategories}
    />
  );
};
